import React, { useEffect, useState } from "react";
import "./wishlistCard.scss";
import { Button } from "@mui/material";
import { Link } from "react-router-dom";
import wishlistStore from "../../store/wishlistStore";
import productStore from "../../store/productStore";
import { PRODUCT_IMAGE_URL } from "../../constant";
import categoryStore from "../../store/categoryStore";

const WishlistCard = ({ item }) => {
  const WishlistStore = wishlistStore();
  const ProductStore = productStore();
  const CategoryStore = categoryStore();
  const [wishlistItem, setWishlistItem] = useState(null);
  const [categoryName, setCategoryName] = useState();
  const [to, setTo] = useState("");

  useEffect(() => {
    for (let i = 0; i < ProductStore.mProduct.length; i++) {
      if (ProductStore.mProduct[i]._id === item.productID) {
        setWishlistItem(ProductStore.mProduct[i]);
        return;
      }
    }
  }, []);

  useEffect(() => {
    if (wishlistItem) {
      if (CategoryStore.category) {
        CategoryStore.category.filter((category) => {
          return (
            category._id === wishlistItem.categoryID &&
            setCategoryName(category.categoryName)
          );
        });
      }
    }
  }, [wishlistItem]);

  useEffect(() => {
    if (categoryName) {
      setTo(
        `/${categoryName}/${wishlistItem.productName}/${wishlistItem._id}/details`
      );
    }
  }, [categoryName]);

  return (
    <div className="wishlist-card">
      <div className="single-wishlist-card">
        <Link to={to}>
          <div className="product-img-container">
            <img
              src={
                wishlistItem &&
                PRODUCT_IMAGE_URL + wishlistItem.productImages[0]
              }
              alt="product-img"
              className="product-img"
            />
          </div>
          <div className="basic-details">
            <div className="product-name">
              {wishlistItem && wishlistItem.productName}
            </div>
            <div className="price-container">
              {wishlistItem && wishlistItem.salePrice && (
                <div className="sale-price">
                  ₹{wishlistItem && wishlistItem.salePrice}
                </div>
              )}
              <div
                className={`regular-price ${
                  wishlistItem && wishlistItem.salePrice && "is-sale"
                }`}
              >
                ₹{wishlistItem && wishlistItem.regularPrice}
              </div>
            </div>
          </div>
        </Link>
        <div className="btn-container">
          <Button
            className="btn"
            onClick={() =>
              WishlistStore.removeToWishlist({
                wishlistID: item._id,
                productID: item._id,
                productName: item.productName,
                productPrice: item.salePrice
                  ? item.salePrice
                  : item.regularPrice,
              })
            }
          >
            Remove
          </Button>
        </div>
      </div>
    </div>
  );
};

export default WishlistCard;
